<!-- Copyright (c) 2022 VMware, Inc. All rights reserved. VMware Confidential -->
<clr-checkbox-container>
    <clr-checkbox-wrapper *ngFor="let item of items">

        <input type="checkbox"
               clrCheckbox
               *ngIf="item.value !== 'EMPTY'"
               [id]="item.value"
               [value]="item.value"
               [name]="item.label"
               [(ngModel)]="item.selected"
               (ngModelChange)="onCheckboxChecked()"/>
        <label [for]="item.name"
               [ngClass]="{'divider': item.value === 'EMPTY'}">
            <ng-container *ngIf="item.value !== 'EMPTY'">
                {{ item.label }}
            </ng-container>
        </label>
    </clr-checkbox-wrapper>
</clr-checkbox-container>
<button type="button" class="btn btn-sm btn-outline" (click)="onButtonClick()">
    {{ buttonText | vtranslate }}
</button>
